<div style="margin: 10px;">
  <ul class="nav nav-tabs" style="margin: 10px 0 15px 0">
      <li *ngFor="let item of menu_list;let i = index" class="nav-item"  style="cursor:pointer"  (click)="choose(item.id)">
          <span   [ngClass]="menu_now==item.id?'active':''" class="nav-link" href="#">{{item.name}}</span>
      </li>
  </ul>
  <div style="padding:30px;margin-left:10px ;" *ngIf="menu_now=='2'">
    <select name="selectedQuantity"  class="form-control" (change)="init_list()" [(ngModel)]="search_type_id">
        <option *ngFor="let option of type_list" [value]="option.id" >{{option.name}}</option>
    </select>
    <app-table-v2  *ngIf="data.length > 0" [type]="1" [tcontent]="tcontent" [data]="data"> 
        <ng-template let-post #operation_dk>
            <div *ngIf="post.key == 'is_enable'">
                <button class="btn" (click)="post.val.is_enable=1;save(post.val,-1)" [class]="post.val.is_enable==1?'btn-danger':'btn-secondary'">上架</button>
                <button class="btn" (click)="post.val.is_enable=0;save(post.val,-1)" [class]="post.val.is_enable==1?'btn-secondary':'btn-danger'" style='margin-left: 10px;'>下架</button>
            </div>
            <div *ngIf="post.key == 'gg'">
                <button class="btn btn-info" (click)="edit_data=post.val;now='1'"  data-toggle="modal" data-target=".bd-example-modal-xl">編輯多標題</button>
                <button class="btn btn-danger" (click)="edit_data=post.val;now='2'"  data-toggle="modal" data-target=".bd-example-modal-xl" style='margin-left: 10px;'>編輯設定檔</button>
            </div>
        </ng-template>      
    </app-table-v2>
  </div>
  <div *ngIf="menu_now=='1'">
    <app-table-v2  *ngIf="data.length > 0" [type]="1" [tcontent]="tcontent_active" [data]="data"> 
      <ng-template let-post #operation_dk>
          <div *ngIf="post.key == 'gg'">
              <button class="btn btn-danger" (click)="edit_data=post.val;now='2'"  data-toggle="modal" data-target=".bd-example-modal-xl" style='margin-left: 10px;'>編輯設定檔</button>
          </div>
      </ng-template>      
    </app-table-v2>
  </div>
  <app-pagnation (callback)="callback($event)" [data]="pageobjstr"></app-pagnation> 
  <div *ngIf="data.length==0">無資料</div>
</div>




<div 
  *ngIf="edit_data"
  class="modal fade bd-example-modal-xl" tabindex="-1"
   role="dialog"  data-keyboard="false" data-backdrop="static" 
   aria-labelledby="myExtraLargeModalLabel" aria-hidden="true"
>
    <div class="modal-dialog modal-xl">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
            <h5 class="modal-title">操作</h5>
            <button type="button" class="close" data-dismiss="modal">&times;</button>
        </div>





        <div class="modal-body" *ngIf="menu_now=='1'"> 
          <div class="card text-center border ">
            <div class="card">

              <div class="card-header">
              <h3>設定訊息內容</h3>
                <hr>
               <h4>可用變數:</h4> <button class="btn btn-primary" (click)="add_var(item.id)" *ngFor="let item of varable_list">{{item.name}}</button>
              </div>
                <div class="card-body blue_left">
      
                <div  style="margin-top:13px;"> 
                  <textarea
                  style="height: 75px;"        
                  (select)="select($event);mouse_obj.select = 1;mouse_obj.target = 0" 
                  (click)="select($event);mouse_obj.select = 1;mouse_obj.target = 0"  
                  (keyup)="select($event);mouse_obj.select = 1;mouse_obj.target = 0" 
                  class="form-control" [(ngModel)]="edit_data.content_tpl" 
                  >
                  </textarea>
                </div>

              </div> 
            </div> 
          </div> 
        </div>
  

        <div class="modal-body" *ngIf="now == '1' && menu_now=='2'"> 
          <div class="card text-center border ">
            <div class="card">

              <div class="card-header">
              <h3>多標題設定</h3>
                <hr>
               <h4>可用變數:</h4> <button class="btn btn-primary" (click)="add_var(item.id)" *ngFor="let item of varable_list">{{item.name}}</button>
              </div>


              <div class="card-body blue_left">
                  <button class="btn btn-primary" (click)="add_new_title()">新增多標題</button>
                  <div  style="margin-top:13px;"  *ngFor="let item of edit_data.muti_title;let recordIndex = index" > 
                    <div *ngIf="item.status!=0">
                    {{recordIndex+1}}
                    <textarea
                    style="height: 35px;"        
                    (select)="select($event);mouse_obj.select = recordIndex;mouse_obj.target = 0" 
                    (click)="select($event);mouse_obj.select = recordIndex;mouse_obj.target = 0"  
                    (keyup)="select($event);mouse_obj.select = recordIndex;mouse_obj.target = 0" 
                    class="form-control" [(ngModel)]="item.title_tpl" 
                    (change)="item.status=2">
                  </textarea>
                    <textarea 
                    (select)="select($event);mouse_obj.select = recordIndex;mouse_obj.target = 1"
                     (click)="select($event);mouse_obj.select = recordIndex;mouse_obj.target = 1" 
                      (keyup)="select($event);mouse_obj.select = recordIndex;mouse_obj.target = 1"
                       class="form-control" [(ngModel)]="item.content_tpl" 
                       (change)="item.status=2"></textarea>
                    <button (click)="item.status=0" class="btn btn-danger">刪除</button>
                    </div>
                  </div>
              </div> 

            </div> 
          </div> 
        </div>

        <!-- Modal body -->
        <div class="modal-body" *ngIf="now == '2' && edit_data.info.condition  && menu_now=='2'"> 
          <div class="card text-center border ">
            <div class="card">
              <div class="card-header">
                <ul class="nav nav-pills card-header-pills nav-justified" id="bologna-list" role="tablist">
                  <li class="nav-item">
                    <span class="nav-link" style="cursor: pointer;" (click)="sub_now='2'" [class]="sub_now=='2'?'active':''"  role="tab" aria-controls="history" aria-selected="false">推播目標</span>
                  </li>
                  <li class="nav-item">
                    <span class="nav-link" style="cursor: pointer;" (click)="sub_now='1'" [class]="sub_now=='1'?'active':''" role="tab" aria-controls="description" aria-selected="true">配對條件</span>
                  </li>
                  <li class="nav-item">
                    <span class="nav-link" style="cursor: pointer;"  (click)="sub_now='3'"  [class]="sub_now=='3'?'active':''" role="tab" aria-controls="deals" aria-selected="false">發送時間</span>
                  </li>
                </ul>
              </div>
              <div class="card-body blue_left">
                <div *ngIf="sub_now=='1'">
                  <h6 class="card-subtitle mb-2">推薦者是否熱門</h6>
                  <div class="tab-content mt-3 blue_body">
                    <input type="radio" [disabled]="power <= 4" name="是"  class="with-gap" [(ngModel)]="edit_data.info.condition.is_hot" [value]="1">
                    <span (click)="edit_data.info.condition.is_hot = power > 4 ? 1 : edit_data.info.condition.is_hot" style="cursor: pointer;">是</span>  
                    <input type="radio" [disabled]="power <= 4" name="否"  class="with-gap" [(ngModel)]="edit_data.info.condition.is_hot" [value]="-1">
                    <span (click)="edit_data.info.condition.is_hot = power > 4 ? -1 : edit_data.info.condition.is_hot" style="cursor: pointer;">否</span>  
                  </div>
                  <h6 class="card-subtitle mb-2"
                  >推薦者是否活躍</h6>
                  <div class="tab-content mt-3 blue_body">
                    <input type="radio" [disabled]="power <= 4" name="活躍"  class="with-gap"
                     [(ngModel)]="edit_data.info.condition.is_active"               
                    [value]="1">
                    <span (click)="edit_data.info.condition.is_active = power > 4 ? 1 : edit_data.info.condition.is_active" style="cursor: pointer;">是</span>  
                    <input type="radio" [disabled]="power <= 4" name="活躍"  class="with-gap" [(ngModel)]="edit_data.info.condition.is_active" [value]="-1">
                    <span (click)="edit_data.info.condition.is_active = power > 4 ? -1 : edit_data.info.condition.is_active" style="cursor: pointer;">否</span>  
                  </div>
                  <h6 class="card-subtitle mb-2">觀看關係</h6>
                  <div class="tab-content mt-3 blue_body">
                      <select  [disabled]="power <= 4" name="selectedQuantity"  class="form-control" [(ngModel)]="edit_data.info.condition.view_relation">
                        <option *ngFor="let option of view_relation_list" [value]="option.id" >{{option.name}}</option>
                      </select>
                  </div>
                  <h6 class="card-subtitle mb-2">追蹤關係</h6>
                  <div class="tab-content mt-3 blue_body">
                    <select  [disabled]="power <= 4" name="selectedQuantity"  class="form-control" [(ngModel)]="edit_data.info.condition.love_relation">
                      <option *ngFor="let option of love_relation_list" [value]="option.id" >{{option.name}}</option>
                    </select>
                  </div>
                  <h6 class="card-subtitle mb-2">興趣匹配</h6>
                  <div class="tab-content mt-3 blue_body">
                    <select  [disabled]="power <= 4" name="selectedQuantity"  class="form-control" [(ngModel)]="edit_data.info.condition.hobby_match">
                      <option *ngFor="let option of hobby_list" [value]="option.id" >{{option.name}}</option>
                    </select>
                  </div>
                  <h6 class="card-subtitle mb-2">匹配優先順序</h6>
                  <div class="tab-content mt-3 blue_body">
                    <span class="tips">數字越大越優先</span>
                    <p class="card-text ">
                      <input  [disabled]="power <= 4" class="form-control" type="number" [(ngModel)]="edit_data.info.condition.order">
                    </p>
                  </div>
                  <h6 class="card-subtitle mb-2">年紀規則</h6>
                  <div class="tab-content mt-3 blue_body">
                    <select  [disabled]="power <= 4" name="selectedQuantity"  class="form-control" [(ngModel)]="edit_data.info.condition.age_match.type">
                      <option *ngFor="let option of age_list" [value]="option.id" >{{option.name}}</option>
                    </select>
                    <div *ngIf="edit_data.info.condition.age_match.type == 1">
                      <span class="tips">最小歲數</span><input class="form-control" type="number" [(ngModel)]="edit_data.info.condition.age_match.min">
                      <span class="tips">最大歲數</span><input class="form-control" type="number" [(ngModel)]="edit_data.info.condition.age_match.max">
                    </div>
                    <div *ngIf="edit_data.info.condition.age_match.type == 2">
                      <span class="tips">與自己相差歲數</span><input class="form-control" type="number" [(ngModel)]="edit_data.info.condition.age_match.me_diff">
                    </div>
                    <div *ngIf="edit_data.info.condition.age_match.type == 3">
                      <span class="tips">指定歲數</span><input class="form-control" type="number" [(ngModel)]="edit_data.info.condition.age_match.target">
                    </div>
                  </div>
                </div>
                <div *ngIf="sub_now=='2'">

                  <h6 class="card-subtitle mb-2">推播對象</h6>
                  <div class="tab-content mt-3 blue_body">
                    <input [disabled]="power <= 4"  type="radio" name="推播對象"  class="with-gap" [(ngModel)]="edit_data.info.recommend.pusher" [value]="1">
                    <span (click)="edit_data.info.recommend.pusher = power > 4 ? 1 : edit_data.info.recommend.pusher" style="cursor: pointer;">男生</span>   
                    <input [disabled]="power <= 4"  type="radio" name="推播對象"  class="with-gap" [(ngModel)]="edit_data.info.recommend.pusher" [value]="2">
                    <span (click)="edit_data.info.recommend.pusher = power > 4 ? 2 : edit_data.info.recommend.pusher" style="cursor: pointer;">女生</span>   
                  </div>

                  <h6 class="card-subtitle mb-2">推薦對象</h6>
                  <div class="tab-content mt-3 blue_body">
                    <select [disabled]="power <= 4"  name="selectedQuantity"  class="form-control" [(ngModel)]="edit_data.info.recommend.target">
                      <option *ngFor="let option of push_user_list" [value]="option.id" >{{option.name}}</option>
                    </select>

                    <div *ngIf="edit_data.info.recommend.target == 1 || edit_data.info.recommend.target == 2">
                      <span class="tips">會員id可從會員資料表取得</span>
                      <input (change)="check_user(edit_data.info.recommend.user_uid)" class="form-control"  [(ngModel)]="edit_data.info.recommend.user_uid">
                      <div style="margin-top: 10px;" *ngIf="check_user_info!=-1">
                        <img loading="lazy" *ngIf="check_user_info!=-1" style="height: 50px;" [src]="check_user_info.profile_pic">
                        <span class="tips">{{check_user_info.name}}({{check_user_info.gender==1?'男生':'女生'}})</span>
                      </div>
                    </div>
                  </div>

                  <h6 class="card-subtitle mb-2">推播圖片</h6>
                  <div class="tab-content mt-3 blue_body">
                    <input [disabled]="power <= 4"  type="radio" name="推播圖"  class="with-gap" [(ngModel)]="edit_data.info.recommend.adv_pic" [value]="1">
                    <span (click)="edit_data.info.recommend.adv_pic = power > 4 ? 1 : edit_data.info.recommend.adv_pic" style="cursor: pointer;">大頭貼</span>    
                    <input [disabled]="power <= 4"  type="radio" name="推播圖"  class="with-gap" [(ngModel)]="edit_data.info.recommend.adv_pic" [value]="2">
                    <span (click)="edit_data.info.recommend.adv_pic = power > 4 ? 2 : edit_data.info.recommend.adv_pic" style="cursor: pointer;">動態</span>  
                    <input [disabled]="power <= 4"  type="radio" name="推播圖"  class="with-gap" [(ngModel)]="edit_data.info.recommend.adv_pic" [value]="-1">
                    <span (click)="edit_data.info.recommend.adv_pic = power > 4 ? -1 : edit_data.info.recommend.adv_pic" style="cursor: pointer;">無</span>  
                  </div>
                  <span *ngIf="edit_data.info.recommend.adv_pic!=-1">
                    <h6 class="card-subtitle mb-2">模糊</h6>
                    <div class="tab-content mt-3 blue_body">
                      <div class="tips">推播照片是否使用高斯模糊</div>
                      <input [disabled]="power <= 4"  type="radio" name="模糊"  class="with-gap" [(ngModel)]="edit_data.info.recommend.fuzzy" [value]="1">
                      <span (click)="edit_data.info.recommend.fuzzy = power > 4 ? 1 : edit_data.info.recommend.fuzzy" style="cursor: pointer;">是</span> 
                      <input [disabled]="power <= 4"  type="radio" name="模糊"  class="with-gap" [(ngModel)]="edit_data.info.recommend.fuzzy" [value]="-1">
                      <span (click)="edit_data.info.recommend.fuzzy = power > 4 ? -1 : edit_data.info.recommend.fuzzy" style="cursor: pointer;">否</span>
                    </div>
                  </span>
                </div>
                <div *ngIf="sub_now=='3'">



                  <h6  class="card-subtitle mb-2">發送時間</h6>
                  <div class="tab-content mt-3 blue_body">
                      <select  [disabled]="power <= 4" name="selectedQuantity"  class="form-control" [(ngModel)]="edit_data.info.post_time.time_id">
                        <option *ngFor="let option of time_list" [value]="option.id" >{{option.name}}</option>
                      </select>
                  </div>

                  <button *ngIf="power > 4" (click)="edit_data.info.post_time.day=[1,2,3,4,5,6,7]" class="btn btn-primary">每天</button>
                  <button *ngIf="power > 4" (click)="edit_data.info.post_time.day=[6,7]" class="btn btn-primary">周末</button>
                  <h6 style="margin-top:10px" class="card-subtitle mb-2">發送日</h6>
                  <div class="tab-content mt-3 blue_body">
                      <div class="tips">請選擇發送日為哪幾天</div>
                      <ul class="list-group">
                        <li class="list-group-item" *ngFor="let item of day_list">
                          <input type="checkbox" 
                          [disabled]="power <= 4"
                          [checked]="edit_data.info.post_time.day.includes(item.id*1)" 
                          name="list_name" value="{{item.id}}"
                          (change)="ck_date(edit_data.info.post_time.day,item.id*1)"/>
                         
                          <span (click)="power > 4 ? ck_date(edit_data.info.post_time.day,item.id*1):power=power;" style="cursor: pointer;">{{item.name}}</span>
                        </li>
        
                      </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
  
        <!-- Modal footer -->
        <div class="modal-footer" *ngIf="menu_now=='1'">
          <button type="button"  (click)="save(edit_data,now)"  class="btn btn-primary" data-dismiss="modal">確認</button>
          <button type="button" (click)="init_list()"  class="btn btn-danger" data-dismiss="modal">取消</button>
        </div>

          <div class="modal-footer" *ngIf="menu_now=='2'">
              <button type="button" *ngIf="(now=='2' && power>4) || now =='1'" (click)="save(edit_data,now)"  class="btn btn-primary" data-dismiss="modal">確認</button>
              <button type="button" (click)="init_list()"  class="btn btn-danger" data-dismiss="modal">取消</button>
          </div>
        </div>
    </div>
  </div>
  
  <app-spinner [loading]="loading"></app-spinner>